import { render, staticRenderFns } from "./UserSingleDetails.vue?vue&type=template&id=73ca99ca&"
import script from "./UserSingleDetails.vue?vue&type=script&lang=js&"
export * from "./UserSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports